import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { InfoTooltip } from 'ui';

const StyledLink = styled.a`
  font-size: 18px;
  text-decoration: underline;
`;

const EmailLink = ({
  children,
  ...rest
}) =>
  <InfoTooltip width={null} content={children}>
    <StyledLink {...rest}>{children}</StyledLink>
  </InfoTooltip>;

EmailLink.propTypes = {
  rest: PropTypes.string,
  children: PropTypes.node,
};

export default EmailLink;
